import * as StM from '../../models/store';
import BaseReducer from '../baseReducer';
import * as _ from 'lodash';

export default class EditAddonDialogReducer extends BaseReducer {
    static handle(state: StM.IEditAddonDialogStoreState = new StM.EditAddonDialogStoreState(), action: any): StM.IEditAddonDialogStoreState {
        switch (action.type) {
            case 'Dialogs/Admin/EditAddon/Open': {
                return <StM.IEditCoachFeeTierDialogStoreState>_.assign({}, state, { isOpened: true, id: action.id });
            }
            case 'Dialogs/Admin/EditAddon/Close': {
                return <StM.IEditCoachFeeTierDialogStoreState>_.assign({}, state, { isOpened: false });
            }
            default: {
                return state;
            }
        }
    }
}
